import { createStore } from 'vuex';
import idea from './idea';
import ideas from './ideas';
import digitalProducts from './digitalProducts';
import digitalProduct from './digitalProduct';
import shop from './shop';
import account from './account';
import user from './user';
import settings from './settings';
import platform from './platform';
import notifications from './notifications';
import dms from './dms';
import metrics from './metrics';
import publishingCore from './publishingCore';
import userPaymentInfo from './user/userPaymentInfo';
import userTaxation from './user/userTaxation';
import userTrolley from './user/userTrolley';

export default createStore({
  modules: {
    idea,
    ideas,
    digitalProducts,
    digitalProduct,
    publishingCore,
    shop,
    account,
    user,
    settings,
    platform,
    notifications,
    dms,
    metrics,
    userPaymentInfo,
    userTaxation,
    userTrolley,
  },
});
